module.exports = __webpack_public_path__ + "img/Visa.39fc91d4.svg";